import { CommonModule } from '@angular/common';
import { Component, ContentChildren, Input, OnInit, QueryList, TemplateRef }  from '@angular/core';
import { PanelModule } from "primeng/panel";

@Component({
  selector: 'app-panel-card',
  standalone: true,
  imports: [CommonModule, PanelModule],
  templateUrl: './panel-card.component.html',
  styleUrls: ['./panel-card.component.scss']
})

export class PanelCardComponent implements OnInit {
  @Input() data:any= {};
  @ContentChildren(TemplateRef) templateHeader!:QueryList<TemplateRef<any>>;
  @Input() isCardToggleable:boolean=false;

  constructor() { 
  }
  
  ngOnInit(): void {
  }

  panelToggled(event:boolean){
    this.data.collapsed = event;
  }
}
